import Cookies from 'js-cookie';
import { HYDRATE } from 'next-redux-wrapper';

import { ActionTypeEnum } from 'redux/ActionTypeEnum';

const initialState = {
	confirm: null,
	otp: null,
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case HYDRATE: {
			return { ...state, ...action.payload['landing'] };
		}

		case ActionTypeEnum.etma_registration_request_landing: {
			Cookies.remove('etma_id');

			return { ...state };
		}

		case ActionTypeEnum.etma_registration_success_landing: {
			Cookies.set('form-etma', JSON.stringify(action.payload.form));
			Cookies.set('etma_id', JSON.stringify({ etma_id: action.payload?.response?.EtmaRegistrationId }));

			return { ...state, confirm: action.payload.response };
		}

		default:
			return state;
	}
};
export { reducer as landing };

export * from './selectors';
